import { useCallback, useMemo, useRef } from 'react'
import { Col, Row } from 'antd'
import cx from 'classnames'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import { ImageType } from '../types'
import { BlockSectionTitle, BlockWrapper, BynderPicture, Container, CTALink, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


ImageGridSquare.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({
      image: ImageType,
      tag: PropTypes.string,
      title: PropTypes.string,
      text: PropTypes.string,
      cta_link: PropTypes.string,
    })),
    cta_link_caption: PropTypes.string,
    cta_link_type: PropTypes.string,
  }),
}

export default function ImageGridSquare({
  data = {
    columns: [],
  },
}) {
  const secondOption = useRef()
  const onMouseEnter = useCallback(event => {
    secondOption.current.classList.remove(classNames.hover)
    event.target.classList.add(classNames.hover)
  }, [])
  const onMouseLeave = useCallback(event => {
    event.target.classList.remove(classNames.hover)
    secondOption.current.classList.add(classNames.hover)
  }, [])
  const options = useMemo(() => get(data, 'columns', []).map(({ image, tag, heading, text, cta_link: ctaLink }, index) => (
    <Col key={index} span={24} md={12} xl={8}>
      <div
        ref={index === 1 ? secondOption : null}
        className={cx(classNames.container, index === 1 && classNames.hover)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <BynderPicture
          priority
          image={image}
          desktopImage={{
            maxWidth: 550,
            maxHeight: 550,
            sizes: '(max-width: 765px) 100vw, (max-width: 1280px) 50vw, (max-width: 1920px) 33vw, 550px',
          }}
          mobileImage={{
            maxWidth: 550,
            maxHeight: 550,
            sizes: '100vw',
          }}
        />
        <div className={classNames.inner}>
          <div className={classNames.innerInfo}>
            {tag && <Typography color="light-black" className={classNames.tag}>{tag}</Typography>}
            <Typography variant="h2" className={classNames.title}>{heading}</Typography>
            <Typography color="light-black" className={classNames.text}>{text}</Typography>
          </div>
          <div className={classNames.borderTop} />
          <div className={classNames.borderRight} />
          <div className={classNames.borderBottom} />
          <div className={classNames.borderLeft} />
          <CTALink
            cta={data.cta_link_caption}
            type={data.cta_link_type}
            ctaURL={ctaLink}
            isUnderline
            className={classNames.cta}
          />
        </div>
      </div>
    </Col>
  )), [data.columns])

  return (
    <BlockWrapper>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        <Row gutter={[30, 30]}>{options}</Row>
      </Container>
    </BlockWrapper>
  )
}
